
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.6 11.3L11.9 21c-2.5 2.5-6.5 2.5-9 0s-2.5-6.5 0-9l9.7-9.7c1.6-1.6 4.3-1.6 6 0 1.6 1.6 1.6 4.3 0 6L8.9 18c-.8.8-2.2.8-3 0-.8-.8-.8-2.2 0-3l9-8.9","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    